<template>
  <p class="bank__item">
    <picture>
      <img :src="logoPath" />
    </picture>
    <span class="font--m-4">
      {{ bankName }}
    </span>
  </p>
</template>

<script>
export default {
  props: {
    bankCode: {
      type: String,
      required: true,
    },
    bankName: {
      type: String,
      required: true,
    },
  },
  computed: {
    logoPath() {
      return require('@/assets/images/banks/' + this.bankCode + '.jpg')
    },
  },
}
</script>

<style lang="scss" scoped>
.bank__item {
  display: flex;
  align-items: center;

  line-height: 1;

  margin: 0;

  img {
    max-width: 90px;
    width: 100%;
    object-fit: contain;
  }

  span {
    white-space: nowrap;

    margin-left: 12px;
  }
}
</style>
